export default "__VITE_ASSET__DUAu3Q_I__";